import { createStore, applyMiddleware, compose } from "redux";
import {thunk} from "redux-thunk";

import rootReducer from "@/store/reducers/";
import cookieMiddleware from "@/store/middleware/cookieMiddleware";
// import loadingBarMiddleware from "store/middleware/loadingBarMiddleware";

const composeEnhancers =
    typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
		window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const enhancer = composeEnhancers(
	applyMiddleware(thunk, cookieMiddleware),
);
const store = createStore(rootReducer, enhancer);

// const store = createStore(
// 	rootReducer,
// 	compose(
// 		applyMiddleware(
// 			thunkMiddleware,
// 			cookieMiddleware,
//             // loadingBarMiddleware
//         ),
// 		//window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
// 	),
// );
export default store;